import './button-loader.scss';

import React from 'react';

const ButtonLoader = ({ ...props }) => (
	<div className='loading'>
		<span {...props}></span>
		<span {...props}></span>
		<span {...props}></span>
	</div>
);

export default ButtonLoader;
